import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { ChangeEvent } from "react";

import { Tooltip } from "../tooltip/Tooltip";
import useFieldData from "./useFieldData";
import useFieldName from "./useFieldName";

interface Props {
  fieldData: Record<string, Field<string>>;
  name: string;
  fieldName: string;
  value?: boolean;
  id?: string;
  onChange?: (value: boolean) => void;
  required?: boolean;
}

const SingleCheckbox = (props: Props) => {
  const { name, fieldName } = useFieldName(props.name, props.fieldName);
  const { heading, tooltip } = useFieldData(props.fieldData, name);

  const onFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
    const fieldValue = e.target.checked;
    if (props.onChange) {
      props.onChange(fieldValue);
    }
  };

  return (
    <div className="form-row">
      <div className="form-item full-width checkbox">
        <input
          className="form-input-checkbox"
          id={fieldName}
          name={fieldName}
          type="checkbox"
          onChange={onFieldChange}
          checked={props.value === true}
          required={props.required}
        />
        <label htmlFor={fieldName}>{heading.value}</label>
        <Tooltip fieldName={fieldName} value={tooltip.value} />
      </div>
    </div>
  );
};

export default SingleCheckbox;
